import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { faBell, faComment } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactDataGrid from "@inovua/reactdatagrid-community";
import "@inovua/reactdatagrid-community/index.css";
import columns from "../../global/columns/adminUserColumns";
import {
  faCaretDown,
  faCirclePlus,
  faGear,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import NewUser from "../Modals/NewUser";
import { selectUser } from "../../redux/slices/userSlice";
import DeleteWarning from "../Modals/DeleteWarning";
import { selectSearch } from "../../redux/slices/itemSlice";
import { useDispatch, useSelector } from "react-redux";
import { setSearch } from "../../redux/slices/itemSlice";
import UserRole from "../UserRole";
import EditUserRoles from "../Modals/EditUserRoles";
import {
  getRolesOfUser,
  getUserRoles,
  hasRole,
  primaryRole,
} from "../../utils/roles";
function AdminUsers() {
  const dispatch =  useDispatch();
  const searchInput = useSelector(selectSearch);
  const currentUser = useSelector(selectUser);
  const adminRole = getUserRoles(currentUser);
  const disabled = !hasRole(adminRole, ["Admin"]);
  const [showModal, setShowModal] = React.useState(false);

  const gridStyle = {
    minHeight: 590,
    border: "none",
    fontSize: "13px",
    fontWeight: "200",
  };
  const showCellBorders = false;
  const showZebraRows = false;

  const [users, setUsers] = useState([]);
  var data = [];
  const fetchUsers = async () => {
    const response = await axios.get(
      `${"https://api.sedihisham.com"}/users/allusers`
    );
    const data = response.data;
    if (data.length !== users.length) {
      setUsers(data);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [users]);

  useEffect(() => {
    dispatch(setSearch(""));
  }, []);

  const [showWarningModal, setShowWarningModal] = React.useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [userToEditRoles, setUserToEditRoles] = useState(null);

  const onRolesSaved = (userId, roles) => {
    setUsers(
      users.map((user) =>
        user.id === userId ? { ...user, roles, role: primaryRole(roles) } : user
      )
    );
  };

  const [filteredData, setFilteredData] = useState(null);

  useEffect(() => {
    setFilteredData(users);
  }, [users]);

  useEffect(() => {
    if (searchInput !== "") {
      setFilteredData(
        users.filter((user) => {
          return user.email.includes(searchInput);
        })
      );
    } else {
      setFilteredData(users);
    }
  }, [searchInput]);

  for (let i = 0; i < filteredData?.length; i++) {
    const user = filteredData[i];
    data = [
      ...data,
      {
        id: user.id,
        email: user.email,
        phone: user.phone_number,
        role: (
          <UserRole
            disabled={disabled || !user.id}
            roles={getRolesOfUser(user)}
            onEdit={() => setUserToEditRoles(user)}
          />
        ),
        registred: user.createdAt?.slice(0, 10),
        delete: (
          <div
            onClick={() => {
              if (!disabled) {
                setItemToDelete({ id: user.id, index: i });
                setShowWarningModal(true);
              }
            }}
            className="bg-[red] cursor-pointer rounded w-fit px-3 py-[2px] text-[white] text-center"
          >
            <FontAwesomeIcon icon={faTrash} />
          </div>
        ),
      },
    ];
  }
  return (
    <div className="flex flex-col justify-between">
      <div className=" p-3 w-full">
        <ReactDataGrid
          idProperty="id"
          columns={columns}
          showCellBorders={showCellBorders}
          showZebraRows={showZebraRows}
          rowHeight={52}
          style={gridStyle}
          dataSource={data}
        />
      </div>
      {showModal ? (
        <NewUser
          users={users}
          setUsers={setUsers}
          setShowModal={setShowModal}
        />
      ) : null}
      {userToEditRoles ? (
        <EditUserRoles
          user={userToEditRoles}
          setShowModal={() => setUserToEditRoles(null)}
          onSaved={onRolesSaved}
        />
      ) : null}
      {showWarningModal ? (
        <DeleteWarning
          url="/users/delete/"
          setShowModal={setShowWarningModal}
          itemToDelete={itemToDelete}
          items={users}
          setItems={setUsers}
        />
      ) : null}
      <div
        onClick={() => !disabled && setShowModal(true)}
        className="cursor-pointer flex items-center text-[#0388CC] h-[30px] mb-[0px] ml-[20px] text-[13px]"
      >
        <div className="mr-2">Add new user </div>
        <div className="text-[20px]">
          <FontAwesomeIcon icon={faCirclePlus} />
        </div>
      </div>
    </div>
  );
}

export default AdminUsers;
